module.exports = __webpack_public_path__ + "img/workplace.100e5d27.jpg";